import { useQuery } from '@tanstack/react-query';
import { CommonApiService, FacilityOption } from '../../../services/commonApi';

/** Facility options for the worker form's default_facility_id dropdown. {id, location}. */
export const useFacilities = (cityId?: number) => {
	return useQuery({
		queryKey: ['common', 'facilities', cityId],
		queryFn: async (): Promise<FacilityOption[]> => {
			const res = await CommonApiService.getFacilities(cityId);
			return (res?.data ?? []) as FacilityOption[];
		},
		staleTime: 5 * 60 * 1000,
		refetchOnWindowFocus: false,
	});
};
